import apiClient from '@/utils/apiClient';
import { WorkflowType } from 'src/enums/EWorkflow';

const WORKFLOW_ANALYSIS_API_PATH = '/api/workflow/agent/:agentId/analysis';

/**
 * Get workflow analysis data
 */
export const getWorkflowAnalysis = async ({ agentId }: { agentId: string }): Promise<any> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: WORKFLOW_ANALYSIS_API_PATH.replace(':agentId', agentId),
	});

	return response;
};

/**
 * Analyzes workflows for conflicts and provides improvement suggestions
 */
export const analyzeWorkflows = async (payload: {
	workflow: any;
	workflowType: WorkflowType;
	scenarioId?: string;
	model?: string;
	agentId: string;
}): Promise<any> => {
	const { agentId, ...body } = payload;
	const response = await apiClient.request({
		method: 'POST',
		endPoint: WORKFLOW_ANALYSIS_API_PATH.replace(':agentId', agentId),
		body,
	});

	return response;
};

/**
 * Accepts an improvement suggestion for a workflow
 */
export const acceptImprovement = async (payload: {
	analysisId: string;
	scenarioId: string;
	enhancedDescription: string;
	workflowType: string;
	agentId: string;
}): Promise<any> => {
	const { agentId, ...body } = payload;
	const response = await apiClient.request({
		method: 'POST',
		endPoint: `${WORKFLOW_ANALYSIS_API_PATH.replace(':agentId', agentId)}/accept-improvement`,
		body,
	});

	return response;
};

/**
 * Rejects an improvement suggestion for a workflow
 */
export const rejectImprovement = async (payload: {
	analysisId: string;
	scenarioId: string;
	agentId: string;
}): Promise<any> => {
	const { agentId, ...body } = payload;
	const response = await apiClient.request({
		method: 'POST',
		endPoint: `${WORKFLOW_ANALYSIS_API_PATH.replace(':agentId', agentId)}/reject-improvement`,
		body,
	});

	return response;
};

/**
 * Removes a conflicting workflow
 */
export const removeConflictWorkflow = async (payload: {
	analysisId: string;
	scenarioId: string;
	workflowName: string;
	agentId: string;
}): Promise<any> => {
	const { agentId, ...body } = payload;
	const response = await apiClient.request({
		method: 'POST',
		endPoint: `${WORKFLOW_ANALYSIS_API_PATH.replace(':agentId', agentId)}/remove-conflict`,
		body,
	});

	return response;
};
